function escapeClipboardValue(value) {
  let stringValue = String(value ?? "");

  if (
    stringValue.includes("\t") ||
    stringValue.includes("\n") ||
    stringValue.includes('"')
  ) {
    stringValue = `"${stringValue.replace(/"/g, '""')}"`;
  }

  return stringValue;
}

export function serializeCellRangeToTsv({
  files,
  navigableFields,
  toFileIndex,
  range,
}) {
  if (!range) return "";

  const rows = [];

  for (let rowIndex = range.minRow; rowIndex <= range.maxRow; rowIndex += 1) {
    const fileIndex = toFileIndex(rowIndex);
    if (fileIndex < 0) continue;

    const file = files[fileIndex];
    if (!file) continue;

    const rowValues = [];
    for (
      let fieldIndex = range.minField;
      fieldIndex <= range.maxField;
      fieldIndex += 1
    ) {
      const fieldId = navigableFields[fieldIndex];
      rowValues.push(escapeClipboardValue(file.modifiedExifData[fieldId]));
    }

    rows.push(rowValues.join("\t"));
  }

  return rows.length > 0 ? `${rows.join("\n")}\n` : "";
}

export function parseClipboardTsv(clipboardText) {
  const rows = [];
  let currentRow = [];
  let currentValue = "";
  let insideQuotes = false;

  for (let index = 0; index < clipboardText.length; index += 1) {
    const char = clipboardText[index];
    const nextChar = clipboardText[index + 1];

    if (insideQuotes) {
      if (char === '"' && nextChar === '"') {
        currentValue += '"';
        index += 1;
      } else if (char === '"') {
        insideQuotes = false;
      } else {
        currentValue += char;
      }
      continue;
    }

    if (char === '"') {
      insideQuotes = true;
      continue;
    }

    if (char === "\t") {
      currentRow.push(currentValue);
      currentValue = "";
      continue;
    }

    if (char === "\n" || (char === "\r" && nextChar === "\n")) {
      currentRow.push(currentValue);
      rows.push(currentRow);
      currentRow = [];
      currentValue = "";
      if (char === "\r") {
        index += 1;
      }
      continue;
    }

    if (char === "\r") {
      currentRow.push(currentValue);
      rows.push(currentRow);
      currentRow = [];
      currentValue = "";
      continue;
    }

    currentValue += char;
  }

  if (currentValue || clipboardText.endsWith("\t")) {
    currentRow.push(currentValue);
  }
  if (currentRow.length > 0) {
    rows.push(currentRow);
  }

  return rows;
}
